// extracted by mini-css-extract-plugin
module.exports = {"userDetailsWindow":"userDetailsWindow__oaHjy","allBusinessAllowedToggle":"allBusinessAllowedToggle__XRJHh","phoneNumberRow":"phoneNumberRow__6QbU0"};